import { render, staticRenderFns } from "./ZimbraMailPricing.vue?vue&type=template&id=e6ab77b8&"
import script from "./ZimbraMailPricing.vue?vue&type=script&lang=js&"
export * from "./ZimbraMailPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports